import React, { useState, useRef } from "react";
import axios from "axios";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ImagePicker({ value, onChange, folder = "uploads", className = "" }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("folder", folder);
      const { data } = await axios.post(`${API}/admin/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={`flex flex-col sm:flex-row gap-3 items-start ${className}`}>
      <div className="h-24 w-24 sm:h-28 sm:w-28 rounded-xl overflow-hidden bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
        {value && typeof value === "string" && value.trim() ? (
          <img src={value} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <span className="text-white/40 text-xs">No image</span>
        )}
      </div>
      <div className="flex-1 grid gap-2 w-full">
        <input
          ref={inputRef}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          onChange={(e) => handleFile(e.target.files?.[0])}
          className="hidden"
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#5FBDD6] hover:bg-[#3FA8C4] disabled:opacity-60 text-[#0B0B0B] font-extrabold tracking-[0.18em] uppercase text-xs px-5 py-2.5 transition-colors w-full sm:w-auto"
          data-testid="image-upload-btn"
        >
          {busy ? <Loader2 className="animate-spin" size={14} /> : <Upload size={14} />}
          {busy ? "Uploading…" : "Upload Image"}
        </button>
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="or paste image path (e.g. /uploads/foo.jpg)"
          className="w-full rounded-lg bg-white/[0.06] border border-white/10 text-white text-xs px-3 py-2 placeholder:text-white/30"
        />
      </div>
    </div>
  );
}
